
export class ErrorItem {
  constructor(error) {
    this.error = error;
  }

  getType () {
    return this.error.type;
  }

  getMessage () {
    return this.error.message;
  }
}



// WEBPACK FOOTER //
// ./src/network/response/error-item.js